import { useEffect } from "react";

export default function survey_mcu_befa_2025() {
  useEffect(() => {
    window.location.href = "https://forms.office.com/Pages/ResponsePage.aspx?id=yJHxX27ETEGHXmgzRnoFVAOAdrwL3CNJpErdXsaKAipUQzdaTTM3WUNRT0NCMlBLQlRRVFVVWVAzRS4u";
  }, []);

  return null;
}